/**
 * 初始化视口高度自定义属性
 * 解决移动端和平板设备中 100vh 不适应屏幕大小的问题
 *
 * 使用方法：
 * 1. 在应用启动时调用 initAppVh()
 * 2. 在 CSS 中使用 calc(var(--vh, 1vh) * 100) 替代 100vh
 */
export function initAppVh(): void {
  // 获取视口区域高度并将其乘以1%以获得1vh单位的值
  const setVh = () => {
    if (!document || !document.documentElement) {
      return;
    }
    const vh = window.innerHeight * 0.01;
    // 然后将--vh自定义属性中的值设置为文档的根
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };

  // 保存具名引用，确保 removeEventListener 能正确匹配
  const handleOrientationChange = () => {
    // 延迟执行，确保 orientationchange 完成后获取正确的窗口高度
    setTimeout(setVh, 100);
  };

  // 确保 DOM 已经准备好
  const initialize = () => {
    // 页面初始化时调用
    setVh();

    // 监听窗口resize事件，视图大小发生变化就重新计算1vh的值
    window.addEventListener('resize', setVh);

    // 监听 orientationchange 事件（移动设备横竖屏切换）
    window.addEventListener('orientationchange', handleOrientationChange);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
}
